import { Link } from 'react-router-dom';

export function NotFoundRoute() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="text-center">
        <div className="text-6xl font-semibold tracking-tight text-slate-300">404</div>
        <h1 className="mt-4 text-xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-slate-500">The page you're looking for doesn't exist.</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-slate-900 px-4 py-2 text-sm text-white"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
